import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./resources";

export const LANGUAGES = {
  en: { code: "en", label: "English", nativeLabel: "English", isRTL: false },
  ar: { code: "ar", label: "Arabic", nativeLabel: "العربية", isRTL: true },
  he: { code: "he", label: "Hebrew", nativeLabel: "עברית", isRTL: true },
};

export const DEFAULT_LANGUAGE = "en";

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  ns: Object.keys(resources[DEFAULT_LANGUAGE]),
  defaultNS: "common",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
